import { FundraiserModuleLink } from '@givmo/fundraisers-module';
import { useActiveOrg } from '../../org/active-org-context';
import { isFundraisersModuleEnabled } from '../../lib/env';
import { useFundraisersNavigation } from './use-fundraisers-navigation';

interface Props {
  charityId: string;
  fundraiserId: string;
  ownerKind: unknown;
  testId: string;
  className?: string;
}

/** The marker is recipient-relative. Unknown metadata never becomes a management link. */
export function CharityFundraiserReportLink(props: Props) {
  if (props.ownerKind !== 'org' || !isFundraisersModuleEnabled()) return null;
  return <OwnedFundraiserReportLink {...props} />;
}

function OwnedFundraiserReportLink({ charityId, fundraiserId, testId, className }: Props) {
  const navigation = useFundraisersNavigation();
  const org = useActiveOrg();
  if (!org.isReady || org.activeCharityId !== charityId) return null;
  return (
    <FundraiserModuleLink
      {...navigation}
      fundraiserId={fundraiserId}
      testId={testId}
      className={className}
      iconOnly
    />
  );
}
